var obj = {
    index: function() {
        this.returnCurrentPage(); // 是否返回当前页面
        this.preloading(); // 预加载
        this.indexSwiper(); // 首页大轮播
        this.indexBind(); // 各种事件绑定
        this.dataTake(); // 数据采集
        this.downloadSelection(); // 下载包选择
    },
    // 下载包选择
    downloadSelection() {
        // 第一页，下载链接
        var iosUrl = 'https://apps.apple.com/jp/app/%E6%9C%80%E5%BC%B7%E3%81%A7%E3%82%93%E3%81%A7%E3%82%93/id1589608687';
        var googleUrl = 'https://play.google.com/store/apps/details?id=com.qcplay.snail.android.jp';

        $('.download-box .take').click(function() {
            $('.ios-btn').attr('href', iosUrl);
            $('.google-btn').attr('href', googleUrl);
        });

        $('.download-btn').click(function() {
            var ua = navigator.userAgent || '';
            var platform = navigator.platform || '';

            var isWindows = /Win/i.test(platform) || /Windows/i.test(ua);
            var isMac = /Mac/i.test(platform) || /Macintosh/i.test(ua);

            if (isMac) {
                $(this).attr('href', iosUrl);
            } else {
                $(this).attr('href', googleUrl);
            }
        });
    },
    // 是否返回当前页面
    returnCurrentPage() {
        window.addEventListener('pageshow', function(event) {
            if (event.persisted) {
                window.location.reload();
            }
        });
    },
    // 图片资源预加载
    preloading: function() {
        //图片预加载
        var queue = new createjs.LoadQueue();
        queue.on("progress", function(e) {
            //加载中的进度
            if (e.progress * 100 >= 10) {
                $(".loading_time span").width(parseInt(e.progress * 100) + '%')
            };
            var numbers = e.progress * 100;
        }, this);
        queue.on("complete", function(e) {
            //加载完成执行操作
            $('.loading_time').remove();
            $('.preloading').addClass('preloading-ani').fadeOut(1000);
            $('.float-time').addClass('float-time-ani')
            $('.index').removeClass('loading');
            $('.bg').addClass('bg-ani');

            setTimeout(function() {
                $('.preloading').remove();
            }, 1000);
        }, this);
        queue.loadManifest([
            //加载图片，不包括后台的
            '/leading/images/pc/loading_bg-dc733c6eaf.png',
            '/leading/images/pc/index_bg2-42cba1ce57.png',
            '/leading/images/pc/content_bg_2-426e10ee10.png',
            '/leading/images/pc/content_bg_2_top-00e153d1c9.png',
            '/leading/images/pc/content_bg_3-cee6c3ecf6.png',
            '/leading/images/pc/content_bg_4-15b8d80cbc.png',
            '/leading/images/pc/content_bg_5-57ee19d29c.png',
            '/leading/images/pc/content_bg_6-b2be87a732.png',
            '/leading/images/pc/content_bg_6_top-70c5c70b33.png',
            '/leading/images/pc/nav/nav_btn_3-a0085217f5.png',
            '/leading/images/pc/m_dt_sz-c672bbb676.png',
            '/leading/images/pc/m_dt_t-5cec4e3d8f.png',
            '/leading/images/pc/m_jdt-66f77b0fe2.png',
        ]);
    },
    // 首页轮播
    indexSwiper: function() {
        var mySwiper = new Swiper('.swiper-container', {
            direction: 'vertical',
            slidesPerView: 'auto',
            spaceBetween: 0,
            mousewheelControl: true,
            resistanceRatio: 0,
            onInit: function(swiper) {
                swiperAnimate(swiper);

                function Ani(btn, page) {
                    $(btn).on('click', function() {
                        mySwiper.slideTo(page, 500, true);
                    });
                }

                // 使用循环来简化重复代码
                for (let i = 1; i <= 6; i++) {
                    Ani(`.nav-btn-${i}`, i - 1);
                }

                var aniLink01 = Ani('.arrow-b', '1');
            },
            onSlideChangeStart: function(swiper) {
                let activeIndex = swiper.activeIndex + 1;
                const $navFixed = $('.nav-fixed');
                const $floatCode = $('.float-code');

                $navFixed.toggleClass('nav-fixed-show', activeIndex > 1);
                $floatCode.toggleClass('float-code-ani', activeIndex === 1);
                $navFixed.find(`.nav-btn-${activeIndex}`).addClass('on').siblings('li').removeClass('on');

                $('.footer').removeClass('footer-on');

                swiperAnimate(swiper);
            },
            onSlideChangeEnd: function(swiper) {
                swiper.activeIndex >= 5 ? $('.rocket').fadeIn() : $('.rocket').fadeOut();
                swiperAnimate(swiper);
            },
        });

        $('body').on('click', '.rocket', function(event) {
            var _this = $(this);
            _this.addClass('rocket-ani')
            mySwiper.slideTo(0, 1000, true);
            setTimeout(function() { _this.fadeOut() }, 1000);
            setTimeout(function() { _this.removeClass('rocket-ani') }, 1500);
        });
    },

    indexBind: function() {
        // 神墟道具显示切换
        $('.benefits-rewards').on('click', 'li', function() {
            const data = $(this).attr('data');
            showRewardBox(data);
        });

        // 神墟进入
        $('.point').click(function(event) {
            var jumpUrl = $(this).attr('url');
            $('.content-06').addClass('content-06-ani');
            $('.prevent').fadeIn();

            setTimeout(function() {
                location.href = jumpUrl;
            }, 1800);
        });

        $('.footer').click(function(event) {
            var _this = $(this);
            _this.hasClass('footer-on') ? _this.removeClass('footer-on') : _this.addClass('footer-on');
            $('.float-code').addClass('float-code-ani');
        });

        // 其他，点击弹窗背景关闭弹窗
        $('.popup_wrap').click(function(event) {
            if ($(event.target)[0] == $(this)[0]) {
                $('.popup_wrap').fadeOut();
            }
        });

        // 其他，奖励弹窗
        function showRewardBox(data) {
            $('.reward-pop-wrap').fadeIn();
            for (let i = 0; i < 6; i++) {
                $('.reward-pop-box').removeClass(`reward-box-${i}`);
            }
            $('.reward-pop-box').addClass(`reward-box-${data}`);
        }
    },

    dataTake: function() {
        $('.take').click(function(event) {
            var data = $(this).attr('take-data');
            console.log(data);
            obj.countNum(data);
        });
    },

    // 获取当前hash的具体参数
    getQueryVariable: function(variable) {
        var query = window.location.href.split('?')[1];
        var vars = query.split("&");
        for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split("=");
            if (pair[0] == variable) {
                return pair[1];
            }
        }
        return (false);
    },
    // 阿里云埋点
    countNum: function(data) {
        setTimeout(() => {
            try {
                __bl.sum(data);
            } catch (e) {
                console.log(e)
            }
        }, 200);
    }
}